(function(app) {

    app.constant("fundsSpecificAccountOptions",
    [
        { Label: "Yes", Value: "Yes" },
        { Label: "No", Value: "No" },
        { Label: "Not Sure", Value: "NotSure" }
    ]);

})(window.app); //jshint ignore:line